import { FOCUSABLE_ELEMENT_SELECTOR } from './focusable-elements-selector';
import { IsInertOptions } from './is-inert-element';

// Constants are only relevant for this function
const IMPLICIT_FOCUSABLE_ELEMENT_SELECTOR_WITHOUT_INERT = `
  a[href]:not([hidden]),
  area[href]:not([hidden]),
  audio[controls]:not([hidden]),
  button:not([disabled]):not([hidden]),
  details summary:not([hidden]),
  embed:not([hidden]),
  iframe:not([hidden]),
  img[usemap]:not([hidden]),
  input:not([disabled]):not([type="hidden"]):not([hidden]),
  select:not([disabled]):not([hidden]),
  textarea:not([disabled]):not([hidden]),
  video[controls]:not([hidden]),
  [contenteditable]:not([disabled]):not([hidden])
`
  .trim()
  .replace(/\s+/g, ' ');

const FOCUSABLE_ELEMENT_SELECTOR_WITHOUT_INERT =
  IMPLICIT_FOCUSABLE_ELEMENT_SELECTOR_WITHOUT_INERT +
  ', [tabindex]:not([disabled]):not([hidden])';

/**
 * Determines whether the given element is focusable.
 * Note: elements with a negative tab index are focusable, but not tabbable.
 */
export function isFocusable(
  element: any,
  options = IsInertOptions,
): element is HTMLElement {
  const { includeUWInert } = options;

  if (includeUWInert) {
    return (
      element?.matches(FOCUSABLE_ELEMENT_SELECTOR) &&
      !element?.closest('[inert], [hidden]')
    );
  }

  return (
    element?.matches(FOCUSABLE_ELEMENT_SELECTOR_WITHOUT_INERT) &&
    !element?.closest('[inert]:not([data-uw-inert]), [hidden]')
  );
}
